<template>
  <div
    v-if="promo"
    class="promo"
    :style="`background-color: ${promo.color}`"
  >
    <BHLink
      v-if="promo.url"
      class="promo__link"
      :href="promo.url"
      target="_blank"
      @click="sendAnalytics(promo.url)"
    />
    <div
      v-if="promo.mobile_top_image || promo.desktop_top_image"
      class="promo__advertising promo__advertising--top"
    >
      <picture>
        <source
          :srcset="promo.mobile_top_image"
          media="(max-width: 767px)"
        />
        <source
          :srcset="promo.desktop_top_image"
          media="(min-width: 768px)"
        />
        <img :src="promo.desktop_top_image" />
      </picture>
    </div>

    <div class="promo__content">
      <slot class="promo__main" />
    </div>

    <div
      v-if="promo.mobile_bottom_image || promo.desktop_bottom_image"
      class="promo__advertising promo__advertising--bottom"
    >
      <picture>
        <source
          :srcset="promo.mobile_bottom_image"
          media="(max-width: 767px)"
        />
        <source
          :srcset="promo.desktop_bottom_image"
          media="(min-width: 768px)"
        />
        <img :src="promo.desktop_bottom_image" />
      </picture>
    </div>

    <BadgesContainer />
  </div>
</template>

<script lang="ts">
  import BHLink from '~/components/BHLink.vue';
  import getSlugFromUrl from '~/utils/getSlugFromUrl';
  import { useSingleArticleStore } from '~/store/singleArticle';
  import BadgesContainer from '~/features/badge/BadgesContainer.vue';

  export default defineNuxtComponent({
    name: 'PromoLayout',

    components: {
      BadgesContainer,
      BHLink,
    },

    computed: {
      article() {
        return useSingleArticleStore().article;
      },

      promo() {
        return this.article?.meta?.promo;
      },
      currentSlug(): string {
        return getSlugFromUrl(useRoute().fullPath);
      },
    },

    methods: {
      // Функция для отправки аналитики клика промо
      sendAnalytics(_promoLink: string) {},
    },
  });
</script>

<style lang="scss" scoped>
  .promo {
    display: flex;
    flex-direction: column;
    align-items: center;

    position: relative;
    min-height: 100vh;
    background-color: #f2f0f0;

    &__link {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
    }

    &__advertising {
      max-width: 1920px;
      overflow: hidden;
      margin: 0 auto;
      width: 100%;
      position: relative;
      &--bottom {
        min-height: 240px;
      }
      &--top {
        min-height: 80px;
        @include tablet {
          min-height: 240px;
        }
      }
      img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
      }
    }

    &__content {
      position: relative;
      z-index: 3;
      width: 100%;
    }

    &__main {
      margin-top: 0;
    }
  }
</style>
